import {
    ASSISTANT_PATH,
    ASSISTANT_RECORD_PATH,
    LEGACY_AGENT_CONFIG_PATH,
    LEGACY_AGENT_PATH,
    LEGACY_AGENT_RECORD_PATH,
    LEGACY_AGENT_TESTING_PATH,
    LEGACY_AGENTS_PATH,
    LEGACY_ASSISTANT_PATH,
    LEGACY_ASSISTANT_RECORD_PATH,
    MARKETING_PATH,
    OVERVIEW_PATH,
} from './constants.ts';
import AssistantPage from './pages/AssistantPage.tsx';
import MarketingPage from './pages/MarketingPage.tsx';
import OverviewPage from './pages/OverviewPage.tsx';
import { legacyRedirect } from './utils/legacyRedirect.tsx';
import { canSeeAgents, canSeeAssistants } from '../../users/utils.ts';

export default [
    {
        path: OVERVIEW_PATH,
        component: OverviewPage,
        condition: ({ user }) => canSeeAssistants(user),
    },
    {
        path: MARKETING_PATH,
        component: MarketingPage,
        condition: ({ user }) => canSeeAssistants(user),
    },
    {
        path: ASSISTANT_PATH,
        component: AssistantPage,
        condition: ({ user }) => canSeeAgents(user),
    },
    {
        path: ASSISTANT_RECORD_PATH,
        component: AssistantPage,
        condition: ({ user }) => canSeeAgents(user),
    },
    { path: LEGACY_AGENTS_PATH, component: legacyRedirect(OVERVIEW_PATH) },
    { path: LEGACY_AGENT_PATH, component: legacyRedirect(ASSISTANT_PATH, { tab: 'activity' }) },
    { path: LEGACY_AGENT_TESTING_PATH, component: legacyRedirect(ASSISTANT_PATH, { tab: 'activity' }) },
    { path: LEGACY_AGENT_RECORD_PATH, component: legacyRedirect(ASSISTANT_RECORD_PATH) },
    { path: LEGACY_AGENT_CONFIG_PATH, component: legacyRedirect(ASSISTANT_PATH) },
    { path: LEGACY_ASSISTANT_PATH, component: legacyRedirect(ASSISTANT_PATH) },
    { path: LEGACY_ASSISTANT_RECORD_PATH, component: legacyRedirect(ASSISTANT_RECORD_PATH) },
];
